export const SEARH_PENDING = 'SEARCH_PENDING';
export const SEARCH_FULFILLED = 'SEARCH_FULFILLED';
export const SEARCH_FAILED = 'SEARCH_FAILED';
export const SET_SEARCHMODAL_STATE_FULFILLED = 'SET_SEARCHMODAL_STATE_FULFILLED';
